import React from 'react';
import PropTypes from 'prop-types';

import SharedConstants from '../../../../shared/sharedConstants.js';
import { connect } from 'react-redux/dist/react-redux.min.js';
import ReduxStore from '../redux/reduxStore.jsx.js';
import Utils from '../utils.js';

import {UserAvatarV2 } from './commonControls.jsx';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import ReactLinkify from 'react-linkify';

import {
    Typography,
    Chip,
    Card,
    CardHeader,
    CardContent,
    IconButton,
} from '@material-ui/core';
import Skeleton from '@material-ui/lab/Skeleton';
import moment from 'moment';
import { Link } from 'react-router-dom';

export default function MPubCard(props) {
    const [isRaised, setIsRaised] = React.useState(false);

    const { card, disableLink, cardLinkFunction } = props;
    const { creator } = card;
    const typeString = card.cardType == SharedConstants.CardType.Evidence
        ? 'EVIDENCE'
        : 'CONJECTURE'

    const mPubCardContent = (
        <CardContent>
        <div className='card-title'>
            {
               card.arpahEntry &&
               <ArpahDisplay {...card.arpahEntry} evidenceStatement={card.title} evidenceCitation={card.citation} />
            }
            {!card.arpahEntry && card.title}
        </div>
        {card.cardType === SharedConstants.CardType.Evidence && !card.arpahEntry &&
            <div className='card-title card-citation'>
                <ReactLinkify>
                    {card.citation}
                </ReactLinkify>
            </div>
        }
        <div className='card-chips'>
            {card.topics.map(topic =>
                <Chip
                    key={card.id + topic.name}
                    className='card-topic'
                    label={topic.name}
                    color='primary'
                    size='small'
                />
            )}
            {card.tags.map(tag =>
                <Chip
                    key={card.id + tag.text}
                    className='card-tag'
                    label={tag.text.split(',')[0]}
                    variant='outlined'
                    size='small'
                />
            )}
        </div>
    </CardContent>
    )
    const mPubCard = (
        <Card className='mPub-card'
            onMouseOver={() => !disableLink && setIsRaised(true)}
            onMouseOut={() => !disableLink && setIsRaised(false)}
            raised={isRaised}
        >
            <div className='cardtype-header'>
                <div className={`cardtype-${typeString.toLowerCase()}`}>
                    {typeString}
                </div>
            </div>
            <CardHeader
                className='mPub-header'
                avatar={<Link to={`/users/profile?idUser=${creator.id}`} style={{color:'inherit'}}><UserAvatarV2 size='medium' userData={creator}/></Link>}
                title={
                    <span className='user-date'>
                    <Link to={`/users/profile?idUser=${creator.id}`} style={{color:'inherit'}}>
                    <Typography style={{fontWeight:'600'}} variant='h6'>
                            {`${creator.firstName} ${creator.lastName}`}
                        </Typography>
                    </Link>
                        <div className='creation-date'>
                            • {moment(card.creationTime).format('lll') + ' EST'}
                        </div>
                    </span>
                }
                subheader={
                    <div className='user-stats'>
                        <Typography className='user-level' variant='body1'>
                            Level {Utils.calculateUserLevel(creator.points)}
                        </Typography>
                        <Typography className='user-points' variant='body1'>
                            {creator.points} points
                        </Typography>
                    </div>
                }
            />
            <hr />
            {!disableLink ? (
                <Link
                    to={`/${cardLinkFunction ? '' : 'listView'}?&cardType=${card.cardType}&idCard=${card.id}&cModalOpen=1`}
                    style={{ textDecoration: 'none' }}
                    onClick={() => cardLinkFunction(card)}
                >
                    {mPubCardContent}
                </Link>
            ) : (
                mPubCardContent
            )}
        </Card>
    );
    return (mPubCard);
}

MPubCard.propTypes = {
    card: PropTypes.object,
    disableLink: PropTypes.bool,
}

MPubCard.defaultProps = {
    disableLink: false,
}

export function MPubCardSimple(props) {
    const { card, disableLink, actions, idIncubator, initialTab} = props;
    let link = `?${card.idSubmitter?`idSubmitter=${card.idSubmitter}`:''}&cardType=${card.cardType}&idCard=${card.id}&cModalOpen=1${idIncubator?`&idIncubator=${idIncubator}`:''}${initialTab?`&initialTab=${initialTab}`:''}`;
    let getType = (cardType) => {
        switch(cardType){
            case SharedConstants.CardType.Evidence:
                return 'EVIDENCE'
            case SharedConstants.CardType.Reasoning:
                return 'CONJECTURE'
            case SharedConstants.CardType.Question:
                return 'QUESTION'
            default:
                return 'UNKNOWN'
        }
    }
    const typeString = getType(card.cardType);
    return (
        <Card className='mPub-card simple'>
            <div className='cardtype-header'>
                <div className={`cardtype-${typeString.toLowerCase()}`}>
                    {typeString}
                </div>
            </div>
            <div className='mPub-container'>
                {actions}
                {disableLink ? (
                    <MPubCardSimpleHeader card={card} />
                ) : (
                    <Link
                        to={link}
                        style={{ textDecoration: 'none' }}
                    >
                        <MPubCardSimpleHeader card={card} />
                    </Link>
                )}
            </div>
        </Card>
    );
}

MPubCardSimple.propTypes = {
    card: PropTypes.object,
    disableLink: PropTypes.bool,
}

MPubCardSimple.defaultProps = {
    disableLink: false,
}

/**
 * MicroPub card used in createConjecture to dispatch
 * link actions
 * @param {*} props
 */
const MPubCardLinkBase = function(props) {
    const { card, addToCreation } = props;
    return (
        <MPubCardSimple
            card={card}
            initialTab={props.initialTab}
            actions={
                <IconButton onClick={() => addToCreation(card)}>
                    <FontAwesomeIcon icon={['fas', 'link']} />
                </IconButton>
            }
        />
    );
}

const mapCardLinkDispatchToProps = (dispatch) => {
    return {
        addToCreation: (evidence) => {
            dispatch(ReduxStore.GreySpaceCardFunctions.addEvidenceToCreation(evidence));
        }
    }
};

export const MPubCardLink = connect(
    () => {},
    mapCardLinkDispatchToProps,
)(MPubCardLinkBase);

export function MPubCardSkeleton(props) {
    return (
        <Card className='mPub-card'>
            <div className='cardtype-header'>
                <div className='cardtype-skeleton' />
            </div>
            <CardHeader
                className='mPub-header'
                avatar={<Skeleton variant='circle' width={64} height={64} />}
                title={<Skeleton variant='text' width={150} />}
                subheader={<Skeleton variant='text' width={75} />}
            />
            <CardContent>
                <Skeleton variant='text' />
            </CardContent>
        </Card>
    );
}

function MPubCardSimpleHeader(props) {
    const { card } = props;
    const { creator } = card;
    const newWindowDecorator = (href, text, key) => (
        <a href={href} key={key} target="_blank">
            {text}
        </a>
    );
    return (
        <CardHeader
            className='mPub-header'
            avatar={<UserAvatarV2 size='medium' userData={creator} />}
            title={
                <>
                    <div className='name-stats'>
                        <span className='user-name'>
                            <Typography style={{fontWeight:'600'}} variant='h6'>
                                {`${creator.firstName} ${creator.lastName}`}
                            </Typography>
                        </span>
                        <div className='user-stats'>
                            <Typography className='user-level' variant='body1'>
                                Level {Utils.calculateUserLevel(creator.points)}
                            </Typography>
                            <Typography className='user-points' variant='body1'>
                                {creator.points} points
                            </Typography>
                        </div>
                    </div>
                    <div className='creation-date'>
                        {moment(card.creationTime).format('MM/DD/YY, h:mma') + ' EST'}
                    </div>
                </>
            }
            subheader={
                (card.cardType != SharedConstants.CardType.Question)?
                <div className='card-title'>
                    {
                       card.arpahEntry &&
                       <ArpahDisplay {...card.arpahEntry} evidenceStatement={card.title} evidenceCitation={card.citation}/>
                    }
                    {!card.arpahEntry && card.title}

                </div>:
                <ReactLinkify componentDecorator={newWindowDecorator}>
                    <div className='card-title'>
                        <Typography color="primary">Question:</Typography>
                        <Typography>{card.title}</Typography>
                    <hr/>
                        <Typography color="primary">Answer:</Typography>
                        <Typography>{card.answer || 'Not answered, yet.'}</Typography>
                    </div>
                </ReactLinkify>
            }
        />
    );
}

function ArpahDisplay(props){
    return(
       <div className={'arpah-display-container'}>
          <div className={'arpah-display-item'}>
             <span className={'label'}>Title:</span>
             {props.shortTitle}
          </div>
           <div className={'arpah-display-item'}>
               <span className={'label'}>Proposed Health Transformation:</span>
               {props.explanation}
           </div>
           <div className={'arpah-display-item'}>
               <span className={'label'}>Current Implementation:</span>
               {props.currentImplementation}
           </div>
           <div className={'arpah-display-item'}>
               <span className={'label'}>What's New:</span>
               {props.whatIsNew}
           </div>
           <div className={'arpah-display-item'}>
               <span className={'label'}>Evidence Statement:</span>
               {props.evidenceStatement}
           </div>
           <div className={'arpah-display-item'}>
               <span className={'label'}>Evidence Citation:</span>
               <ReactLinkify>
                {props.evidenceCitation}
               </ReactLinkify>
           </div>
       </div>
    )

}
